import {Suggest} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {DISABLE_AUTOCOMPLETE, useController, useFormContext} from '@yandex-delivery/form'
import React, {useCallback} from 'react'

import {fetchDetectLocationByCity as fetchCity} from 'src/shared/api'
import {useUserSettingsContext} from 'src/shared/contexts'
import {LocationDetectedVariant} from 'src/shared/types'

type CitySuggestProps = {
  name: string
  'data-testid'?: string 
  pointType: 'a' | 'b'
}

export function CitySuggest({name, pointType, 'data-testid': dataTestId}: CitySuggestProps): React.ReactElement {
  const t = useI18n()
  const {location} = useUserSettingsContext()
  const {control} = useFormContext()
  const {field, fieldState} = useController({name, control})

  const selectHandler = useCallback(
    (value?: LocationDetectedVariant) => {
      field.onChange(value)
    },
    [field],
  )

  return (
    <Suggest<LocationDetectedVariant>
      autoComplete={DISABLE_AUTOCOMPLETE}
      data-testid={dataTestId}
      defaultText={field.value?.address}
      error={fieldState.invalid}
      fetchSuggest={fetchCity}
      helperText={fieldState.error?.message}
      location={location}
      name={name}
      onChange={selectHandler}
      placeholder={t('ndd.point.point-selector.city_placeholder', 'Введите город или регион')}
      pointType={pointType}
      portal={false}
    />
  )
}
